module.exports = __webpack_public_path__ + "static/media/UX_UI.77531c38.png";